import type { TokenBalance } from "../api/usage";

export function billingDate(value?: string | number | null): string | null {
  if (!value) return null;
  const numeric =
    typeof value === "number" || /^\d+$/.test(value) ? Number(value) : null;
  const date = new Date(
    numeric === null ? value : numeric < 1e12 ? numeric * 1000 : numeric,
  );
  return Number.isNaN(date.getTime())
    ? null
    : date.toLocaleDateString(undefined, {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
}
export function subscriptionDetail(
  wallet: TokenBalance | undefined,
  user: { paid: boolean; isTrial?: boolean; trialEnd?: string | number | null },
): string {
  const renewal = billingDate(wallet?.subscriptionRenewsAt);
  const end = billingDate(wallet?.subscriptionPeriodEndsAt);
  if (wallet?.subscriptionStatus === "past_due")
    return "Payment needs attention";
  if (wallet?.subscriptionStatus === "cancelled" && end) return `Ends ${end}`;
  if (wallet?.subscriptionStatus === "expired") return "Subscription ended";
  if (wallet?.trial?.active ?? user.isTrial) {
    const trialEnd = billingDate(wallet?.trial?.endsAt) || end || billingDate(user.trialEnd);
    return trialEnd ? `Trial ends ${trialEnd}` : "Trial active";
  }
  if (renewal) return `Renews ${renewal}`;
  if (end) return `Current period ends ${end}`;
  return user.paid
    ? "Renewal date unavailable"
    : "Explore a plan for monthly tokens.";
}
